import React from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'

import Hyperlink from '../../Hyperlink'

import styles, { linkTheme } from './styles'

const Link = ({ label, href, onClick, external, rel, target, theme = 'primary', asLink }) => (
  <div role="menuitem">
    <Hyperlink
      label={label}
      href={href}
      onClick={onClick}
      external={external}
      rel={rel}
      target={target}
      className={cx(styles.link, linkTheme(theme))}
      as={asLink}
    />
  </div>
)

Link.propTypes = {
  label: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  external: PropTypes.bool,
  rel: PropTypes.string,
  target: PropTypes.string,
  theme: PropTypes.oneOf(['', 'primary', 'secondary', 'success', 'warning', 'error', 'legacy', 'light', 'dark', 'tertiary', 'info']),
  asLink: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({})]),
}

export default Link
